module.exports = __webpack_public_path__ + "img/ponjika-750.06e7e86e.jpg";